module.exports = __webpack_public_path__ + "img/q2.86aa1fc5.svg";